module.exports = __webpack_public_path__ + "img/bab0t1.67bc73ee.png";